<template>
  <div v-if="dataAllLeadsStatus">
    <div class="card has-border">
      <div class="card-header pt-1 pb-1">
        Leads status
        <b-spinner
          v-if="getDAdminIsAllStatusLoading"
          label="Loading..."
          small
        ></b-spinner>
      </div>

      <div class="card-body">
        <dl class="row mb-0">
          <dt class="col-sm-7 fs-9000 fw-500 mb-0">Total Draft</dt>
          <dd class="col-sm-5 text-right fs-9000 fw-600 mb-0">
            {{ dataAllLeadsStatus.leads_draft }}
          </dd>
          <dt class="col-sm-7 fs-9000 fw-500 mb-0">Total Leads Quote</dt>
          <dd class="col-sm-5 text-right fs-9000 fw-600 mb-0">
            {{ dataAllLeadsStatus.leads_quote }}
          </dd>
          <dt class="col-sm-7 fs-9000 fw-500 mb-0">Total Leads Submitted</dt>
          <dd class="col-sm-5 text-right fs-9000 fw-600 mb-0">
            {{ dataAllLeadsStatus.leads_submitted }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'WDDashboardAllLeadsStatus',
  props: ['dataAllLeadsStatus'],
  computed: {
    ...mapGetters(['getDAdminIsAllStatusLoading'])
  }
}
</script>
<style scoped>
.card.has-border {
  border: 1px solid;
}
</style>
